<div class="h-100 w-100 overflow-hidden d-flex flex-column">
    <div class="header">
        <app-default-header *ngIf="headerStateService.isDefaultHeaderDisplayed | async"></app-default-header>
        <app-detail-header *ngIf="headerStateService.isDetailHeaderDisplayed | async"></app-detail-header>
    </div>
    <app-impersonation-indicator></app-impersonation-indicator>
    <app-environment-indicator></app-environment-indicator>
    <div class="flex-grow-1 overflow-y-auto d-flex flex-column">
        <div class="container py-3 flex-grow-1 overflow-y-auto">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-push-notification-indicator></app-push-notification-indicator>
    <div class="footer">
        <app-navbar></app-navbar>

    </div>
    <div class="safe-area bg bg-white"></div>
</div>